import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GeofenceShapeModel } from '../apis/geofencesApi';

interface GeofenceEditorState {
  shape: GeofenceShapeModel | null;
}

const initialData: GeofenceEditorState = {
  shape: null,
};

const geofenceEditorSlice = createSlice({
  name: 'geofenceEditor',
  initialState: initialData,
  reducers: {
    setGeofenceShape: (state, { payload }: PayloadAction<GeofenceShapeModel>) => ({
      ...state,
      shape: {
        ...payload,
      },
    }),
    clearGeofenceShape: (state, action: PayloadAction<void>) => ({
      shape: null,
    }),
  },
});

export const { setGeofenceShape, clearGeofenceShape } = geofenceEditorSlice.actions;

export default geofenceEditorSlice.reducer;
